import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { OdooProjectsNav } from './OdooProjectsNav';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { frenchNavTitles } from '@waadoo/backstage-i18n';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem
          icon={() => item.icon}
          to={item.href}
          text={frenchNavTitles[item.title] ?? item.title}
        />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead
      // Two entries the product does not use, dropped the same way: taking an
      // item is what removes it from `rest()`, and both plugins stay installed
      // because the catalog entity page pulls them in.
      //
      // The ids are those of the *page* extensions — `NavItemBag` keys on the
      // page node, not on the nav item — namely the nameless `PageBlueprint` of
      // the `api-docs` and `techdocs` plugins. `take()` answers null for an id
      // that does not exist, silently, so these two are read from the installed
      // packages rather than guessed.
      nav.take('page:api-docs');
      nav.take('page:techdocs');

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:catalog')}
            {nav.take('page:scaffolder')}
            <SidebarDivider />
            <OdooProjectsNav />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
